import { isValidImageSize, isValidImageType } from '@/js/modules/file_validation';

export function groupByErrors(files, maxItems) {
  const groups = {
    amountError: [],
    sizeError: [],
    typeError: [],
    allowed: [],
  };

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if (!isValidImageSize(file)) {
      groups.sizeError.push(file);
    } else if (!isValidImageType(file.name)) {
      groups.typeError.push(file);
    } else {
      groups.allowed.push(file);
    }
  }

  groups.amountError = groups.allowed.slice(maxItems, groups.allowed.length);
  groups.allowed = groups.allowed.slice(0, maxItems);

  return groups;
}
